import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Styles from './step-forgot-styles.scss';
import { forgotPasswordState, FormStatus, InputKV, ButtonKV } from '.';
import { loginFlowUserState } from '@/presentation/components';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { IconUser } from '@/presentation/components/icons';
const StepForgot = ({ validation, authentication, step, setStep }) => {
    const resetLoginState = useResetRecoilState(forgotPasswordState);
    const [state, setState] = useRecoilState(forgotPasswordState);
    const [loginFlowUser, setLoginFlowUser] = useRecoilState(loginFlowUserState);
    const navigate = useNavigate();
    const validate = (field) => {
        const { email } = state;
        const formData = { email };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.emailError })));
    };
    useEffect(() => resetLoginState(), []);
    useEffect(() => {
        if (state.email)
            validate('email');
    }, [state.email]);
    const handleSubmit = (event) => {
        event.preventDefault();
        try {
            if (state.isLoading || state.isFormInvalid) {
                return;
            }
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            authentication
                .initForgotPassword({
                email: state.email
            })
                .then(() => {
                setLoginFlowUser(state.email);
                setStep(1);
            })
                .catch(err => {
                setState(prev => (Object.assign(Object.assign({}, prev), { mainError: err.message, isLoading: false })));
                console.log(err);
            });
        }
        catch (error) {
            setState(Object.assign(Object.assign({}, state), { isLoading: false, mainError: error.message }));
        }
    };
    return (React.createElement("form", { method: "post", onSubmit: handleSubmit },
        React.createElement("div", { className: Styles.formClass },
            React.createElement("div", { className: Styles.mainPart },
                React.createElement("div", { className: Styles.mainTitle },
                    React.createElement("div", { className: Styles.mainTitleLine1 }, "Reset your password"),
                    React.createElement("div", { className: Styles.mainTitleLine2 }, "Enter the email you registered with and we will send you and email to reset your password")),
                React.createElement(FormStatus, null),
                React.createElement("div", { className: Styles.inputWrap },
                    React.createElement(InputKV, { type: "email", name: "email", placeholder: "Your Email", label: "EMAIL", leftIcon: React.createElement(IconUser, { width: 24, height: 24 }), required: true, id: "input_login_id", hideRequiredDot: true })),
                React.createElement(ButtonKV, { type: "submit", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", width: 113, height: 56, testId: "submit" }, "Send Link"),
                React.createElement(Link, { "data-testid": "link-login", to: "/login", className: Styles.forgotText }, "Back to Login")))));
};
export default StepForgot;
